module.exports = __webpack_public_path__ + "static/arches-blu-01326628a80b7fe8060175e7ff5bdd49.png";